export default __webpack_public_path__ + "media/images/temporary/long-tractor-82d9bd3bbff273bef3b0a4f12d8dd07a.png";